import { spiritoryWebApi } from '@/lib/axios/spiritoryWebApi';
import { BaseApiResponse } from '@/types/api/api-v2';
import { SkuDTO } from '@/types/api/sku';

export default async function getLastViewed() {
  try {
    const {
      data: { data },
    } =
      await spiritoryWebApi.get<BaseApiResponse<SkuDTO[]>>('/sku/last-viewed');

    return data || [];
  } catch (err) {
    throw err;
  }
}
